// extracted by mini-css-extract-plugin
module.exports = {"container":"slogon_container__2Pkob","slognImg":"slogon_slognImg__FY7zy"};